module.exports = __webpack_public_path__ + "static/media/English - Teaching - Transcendence (chowol) - translated by JL.0b2cb618.txt";